import camelcaseKeysDeep from 'camelcase-keys-deep';
import {createApi, fetchBaseQuery, retry} from '@reduxjs/toolkit/query/react';
import {getLocaleFromUrl} from '../../utils/locale-from-url';
import {HqSettingsResponseRaw, TrackingErrorsResponseRaw} from './types-api-raw';
import {PageText, HqSettings, TrackingErrors, DynamicContent} from './types';

const locale = getLocaleFromUrl() || localStorage.getItem('locale') || 'en';

// this is the base api that other api slices will inject endpoints into
export const api = createApi({
  baseQuery: retry(
    fetchBaseQuery({
      baseUrl: import.meta.env.VITE_REACT_APP_API_HOST,
      prepareHeaders: (headers, {getState}) => {
        headers.set('Accept-Language', locale);
        const repairId = (getState() as any).repairId?.value;
        if (repairId) {
          headers.set('X-Repair-Id', repairId);
        }
        return headers;
      },
    }),
    {maxRetries: 0}
  ),
  endpoints: (build) => ({
    getPageText: build.query<PageText, void>({
      query: () => '/page_text',
      transformResponse: (response: PageText) => camelcaseKeysDeep(response) as PageText,
    }),
    getHqSettings: build.query<HqSettings, void>({
      query: () => '/hq_settings',
      transformResponse: (response: HqSettingsResponseRaw) => camelcaseKeysDeep(response) as HqSettings,
    }),
    getTrackingErrors: build.query<TrackingErrors, void>({
      query: () => '/tracking_errors',
      transformResponse: (response: TrackingErrorsResponseRaw) => camelcaseKeysDeep(response) as TrackingErrors,
    }),
    getDynamicContent: build.query<DynamicContent, string | undefined>({
      query: (groupSlug: string) => `/group_dynamic_content?slug=${groupSlug}`,
      transformResponse: (response: DynamicContent) => camelcaseKeysDeep(response) as DynamicContent,
    }),
  }),
});

export const {useGetPageTextQuery, useGetHqSettingsQuery, useGetTrackingErrorsQuery, useGetDynamicContentQuery} = api;
